import { BrowserRouter, useNavigate } from 'react-router-dom';

//TODO: for backwards complatibility, deprecate
export const history = {
  navigate: null,
  push: (page: any, ...rest: any) => history?.navigate && history.navigate(page, ...rest),
};
const NavigateSetter = () => {
  history.navigate = useNavigate();
  return null;
};

export function Router({ children }) {
  return (
    <BrowserRouter>
      <NavigateSetter />
      {children}
    </BrowserRouter>
  );
}
